import { render, staticRenderFns } from "./score-content.vue?vue&type=template&id=62d47502&scoped=true&"
import script from "./score-content.vue?vue&type=script&lang=js&"
export * from "./score-content.vue?vue&type=script&lang=js&"
import style0 from "./score-content.vue?vue&type=style&index=0&id=62d47502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d47502",
  null
  
)

export default component.exports